// 3-way text reconciliation for the concurrent-edit conflict resolver.
// base   = value User B loaded
// mine   = User B's edited value
// theirs = the server's current value (User A's save)

import { toMarkdown } from "@/components/projects/project-description-utils";

export const MERGE_SEPARATOR = "\n\n---\n\n";

export function bothChanged(base: string, mine: string, theirs: string): boolean {
	return mine !== base && theirs !== base && mine !== theirs;
}

// Returns the value to seed an editable merge field with. When both sides
// changed the same text, combine them so the user can reconcile by hand.
export function mergeText(base: string, mine: string, theirs: string): string {
	if (mine === theirs) return mine;
	if (theirs === base) return mine; // only B changed
	if (mine === base) return theirs; // only A changed
	return `${theirs}${MERGE_SEPARATOR}${mine}`; // both changed
}

// Descriptions are markdown; legacy Lexical states are normalized first so
// both sides concatenate as text.
export function mergeDescription(
	base: string,
	mine: string,
	theirs: string,
): string {
	return mergeText(toMarkdown(base), toMarkdown(mine), toMarkdown(theirs));
}
